import React, {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { loadingBus } from "../services/loadingBus";
import { LoadingOverlay } from "@/components/ui/loadingOverlay";

interface LoadingContextData {
  isLoading: boolean;
  start: () => void;
  stop: () => void;
}

const LoadingContext = createContext<LoadingContextData>({
  isLoading: false,
  start: () => {},
  stop: () => {},
});

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider: React.FC<PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [pending, setPending] = useState(0);

  useEffect(() => {
    return loadingBus.subscribe((value) => setPending(value));
  }, []);

  const value = useMemo(
    () => ({
      isLoading: pending > 0,
      start: loadingBus.start,
      stop: loadingBus.stop,
    }),
    [pending]
  );

  return (
    <LoadingContext.Provider value={value}>
      {children}
      <LoadingOverlay show={value.isLoading} />
    </LoadingContext.Provider>
  );
};
